/**
 * The categorical palette, as CSS colour expressions.
 *
 * Six hues, in a fixed order, so a Bar Chart's first series is the same blue a
 * Pie's first slice is. Anything that needs colour to mean *"these are
 * different things"* draws from `CHART_SERIES`; anything that is genuinely in a
 * state — a failed run, an overdue count — reaches for `CHART_SEMANTIC`
 * instead. Using index 5 of `CHART_SERIES` because it happens to be red is the
 * one thing that breaks this.
 *
 * Values are `rgb(var(--wg-cat-n))` rather than literals so a widget follows
 * the theme without every renderer branching on light/dark. See
 * `../catalogWidgets.css` for the tokens themselves.
 */

/** A palette entry at an explicit alpha — heat maps, map regions, area fills. */
export const chartAlpha = (color, alpha) => color.replace(/\)$/, ` / ${alpha})`);

export const CHART_SERIES = Object.freeze([
  'rgb(var(--wg-cat-1))',
  'rgb(var(--wg-cat-2))',
  'rgb(var(--wg-cat-3))',
  'rgb(var(--wg-cat-4))',
  'rgb(var(--wg-cat-5))',
  'rgb(var(--wg-cat-6))',
]);

/** State colours. A funnel stage is not a pass or a failure — do not use these there. */
export const CHART_SEMANTIC = Object.freeze({
  ok: 'rgb(var(--wg-ok))',
  warn: 'rgb(var(--wg-warn))',
  bad: 'rgb(var(--wg-bad))',
});

/** Chrome, shared with the rest of the platform's surfaces. */
export const CHART_INK = Object.freeze({
  title: 'rgb(var(--content))',
  muted: 'rgb(var(--content-muted))',
  line: 'rgb(var(--edge))',
  surface: 'rgb(var(--surface))',
});

/**
 * The i-th series colour, wrapping.
 *
 * `accent` overrides the FIRST series only: the builder lets an author pick one
 * colour for their widget, and repainting every series with it would collapse a
 * four-category chart into one indistinguishable block.
 */
export const seriesColor = (index, accent) =>
  accent && index === 0 ? accent : CHART_SERIES[index % CHART_SERIES.length];

export default CHART_SERIES;
